import { ref } from "vue";

interface UseTimedClickActivationOptions {
  threshold?: number;
  windowMs?: number;
}

export function useTimedClickActivation(
  options: UseTimedClickActivationOptions = {},
) {
  const { threshold = 5, windowMs = 2000 } = options;
  const isActivated = ref(false);
  let clickTimestamps: number[] = [];

  const registerClick = () => {
    const now = Date.now();
    clickTimestamps = [
      ...clickTimestamps.filter((timestamp) => now - timestamp <= windowMs),
      now,
    ];

    if (clickTimestamps.length >= threshold) {
      clickTimestamps = [];
      isActivated.value = true;
    }
  };

  const resetActivation = () => {
    clickTimestamps = [];
    isActivated.value = false;
  };

  return {
    isActivated,
    registerClick,
    resetActivation,
  };
}
